import api from '../lib/axios';
export async function getAlerts(activeOnly = false) {
    const { data } = await api.get('/api/admin/alerts', { params: activeOnly ? { active_only: true } : undefined });
    return data;
}
export async function createAlert(body) {
    const { data } = await api.post('/api/admin/alerts', body);
    return data.data;
}
export async function updateAlert(id, body) {
    const { data } = await api.patch(`/api/admin/alerts/${id}`, body);
    return data.data;
}
export async function deactivateAlert(id) {
    const { data } = await api.patch(`/api/admin/alerts/${id}/deactivate`);
    return data.data;
}
export async function deleteAlert(id) {
    await api.delete(`/api/admin/alerts/${id}`);
}
